<div class="scrollable" [ngClass]="{'scrollable--horizontal': isHorizontal}">
    <ng-content></ng-content>
</div>
